// Private-client content handling.
//
// Across the app a proposal is recognised as belonging to a private individual
// (rather than a company/sector) when `companyNameAndId.name === 'Private Client'`.
// The same string doubles as the key under which private-client copy is stored in
// the sector-keyed dictionaries (SectorsContent, LegalSwornContent, sectors), so a
// private client transparently gets personal-document content (pagelle, carte
// d'identità, certificati di nascita, ...) regardless of the chosen industry.
export const PRIVATE_CLIENT_KEY = 'Private Client';

export const isPrivateClient = (companyNameAndId) =>
  companyNameAndId?.name === PRIVATE_CLIENT_KEY;

// Returns the key to use when looking up sector-keyed content: the private-client
// key for private individuals, otherwise the proposal's industry name.
export const resolveSectorKey = (industry, companyNameAndId) =>
  isPrivateClient(companyNameAndId) ? PRIVATE_CLIENT_KEY : industry?.name;

// Since 03/11/2026 a private person has an account of their own in UNIVERSE, so the
// client name on their order is theirs. Every check in this app goes by the name
// above, so their proposal is read under it: the Bill To comes from `bookedBy`, and
// the tax code stays off the page, as it always has for a private client.
export const asProposalDetails = (details) =>
  details?.companyNameAndId?.accountType === 'individual'
    ? {
        ...details,
        companyNameAndId: {
          ...details.companyNameAndId,
          name: PRIVATE_CLIENT_KEY,
          taxCode: '',
        },
      }
    : details;
